import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./LOSSearchPage.module.css";

import Ellipse from "./Ellipse701.svg";
import Circle from "./Group3541.svg";
import SearchBar from "components/Search";
import { useHistory } from "react-router-dom";
import maddoxBlake from "../../components/IBOItem/icons/MaddoxBlake.svg";
import ethanEmerald from "../../components/IBOItem/icons/EthanEmerald.svg";
import donaldDiamond from "../../components/IBOItem/icons/DonaldDiamond.svg";
import brittScott from "../../components/IBOItem/icons/BrittScott.svg";
import jeffScott from "../../components/IBOItem/icons/JeffScott.svg";
import IBOItem from "components/IBOItem";
import { useTranslation } from "react-i18next";

export function LOSSearchPage({}) {
  const {t} = useTranslation();

  const history = useHistory();

  const data = [
    {
      id: 1,
      pinLevel: 1,
      firstNames: ["Maddox"],
      lastNames: ["Blake"],
      avatars: [`${maddoxBlake}`],
      onSelect: () => alert("IBO Selected"),
      selected: false,
      trend: "up",
      isFreeTrial: true,
    },
    {
      id: 2,
      pinLevel: 3,
      firstNames: ["Ethan"],
      lastNames: ["Emerald"],
      avatars: [`${ethanEmerald}`],
      onSelect: () => alert("IBO Selected"),
      selected: false,
      trend: "up",
      isFreeTrial: true,
    },
    {
      id: 1,
      pinLevel: 4,
      firstNames: ["Donald"],
      lastNames: ["Diamond"],
      avatars: [`${donaldDiamond}`],
      onSelect: () => alert("IBO Selected"),
      selected: false,
      trend: "up",
      isFreeTrial: true,
    },
    {
      id: 1,
      pinLevel: 1,
      firstNames: ["Nam-Deuk"],
      lastNames: ["Kim"],
      avatars: [`${donaldDiamond}`],
      onSelect: () => alert("IBO Selected"),
      selected: false,
      trend: "flat",
      isFreeTrial: false,
    },

    {
      id: 1,
      pinLevel: 1,
      firstNames: ["Angela", "Bruce"],
      lastNames: ["Bennett"],
      avatars: [`${jeffScott}`, `${brittScott}`],
      onSelect: () => alert("IBO Selected"),
      selected: false,
      trend: "flat",
      isFreeTrial: false,
    },
    {
      id: 1,
      pinLevel: 1,
      firstNames: ["Maddox"],
      lastNames: ["Blake"],
      avatars: [`${donaldDiamond}`],
      onSelect: () => alert("IBO Selected"),
      selected: false,
      trend: "flat",
      isFreeTrial: true,
    },

    {
      id: 1,
      pinLevel: 1,
      firstNames: ["paul"],
      lastNames: ["Brown"],
      avatars: [`${donaldDiamond}`],
      onSelect: () => alert("IBO Selected"),
      selected: false,
      trend: "up",
      isFreeTrial: true,
    },
    {
      id: 1,
      pinLevel: 1,
      firstNames: ["Greg", "Julie"],
      lastNames: ["Chapmann"],
      avatars: [`${jeffScott}`, `${brittScott}`],
      onSelect: () => alert("IBO Selected"),
      selected: false,
      trend: "down",
      isFreeTrial: true,
    },
  ];

  const [filter, setFilter] = useState("");

  const onInput = (value) => {
    setFilter(value.toLowerCase());
  };

  // const onClose = () => {
  //   setIsOpen(false)
  // };

  return (
    <div className={styles.container}>
      <div className={styles.search}>
        <div className={styles.searchBar}>
          <SearchBar
            placeholderText={t("Search For IBO")}
            onInput={onInput}
            searchDelay={0}
            minChar={0}
          />
        </div>

        <div className={styles.closeBtn} onClick={() => history.goBack()}>
          <img src={Ellipse} className={styles.ellipse} />{" "}
          <img src={Circle} className={styles.circle} />
        </div>
      </div>
      <div className={styles.list}>
        {filter && (
          <>
            {[...data]
              .filter((i) => i.firstNames[0].toLowerCase().includes(filter.toLowerCase()))
              .map((item) => (
                <div className={styles.ibo}>
                  <IBOItem
                    pinLevel={item.pinLevel}
                    firstNames={item.firstNames}
                    lastNames={item.lastNames}
                    avatars={item.avatars}
                    selected={item.selected}
                    trend={item.trend}
                    isFreeTrial={item.isFreeTrial}
                    // onClick={() => history.push("/los-info")}
                  />
                </div>
              ))}
          </>
        )}
      </div>
    </div>
  );
}

LOSSearchPage.propTypes = {};
